import React, { useEffect } from 'react';
import colorImage from '../../images/colorimage.jpg';
import Logo from '../../images/logo.png'
import { Link as LinkR } from 'react-router-dom';
import { Link as LinkS } from 'react-scroll';
import './About.css';
import Aos from 'aos';
import 'aos/dist/aos.css';

const About = () => {
    useEffect(() => {
        Aos.init({ duration: 2000 });
    }, [])
    return (
        <div className='about' id='about'>
            <div className='about__color'></div>
            <div className='about__left'>
                <img src={colorImage} alt='color' />
            </div>
            <div className='about__right'>
                <div className='about__section'>
                    <p>About</p>
                    <img src={Logo} alt='retbin' />
                </div>
                <div className='about__title'>We work with you to address custom IT solution for your business</div>
                <div className='about__description'>
                    <p>We are retbin an IT consultant Organization.
                    We help our client to resolve  IT related problems,
                    Operate more efficiently and gain a competitive advantages.
                    </p>

                    <p>We are Fast... efficient and reliable</p>
                    <p>
                        We make recommendations, such as suggesting appropriate
                        hardware, software and systems.

                        we design, install and trialling new systems
                        and software, and fixing any issues that arise.
                    </p>

                    <p className="about__extra">
                        We compiling and presenting information,determining
                        requirements and defining project objectives,repairing computer
                        problems and removing viruses.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default About
